import React, { useState } from 'react';
import { Container, Form, Button, Alert, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Formik } from 'formik';
import * as Yup from 'yup';
import '../assets/css/LoginPage.css';
import { FaArrowLeft } from 'react-icons/fa';

const ForgotPassword = () => {
  const { resetPassword } = useAuth();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Email tidak valid')
      .required('Email wajib diisi')
  });

  const handleSubmit = async (values) => {
    try {
      setError('');
      setSuccess('');
      setLoading(true);
      
      await resetPassword(values.email);
      setSuccess('Email reset password telah dikirim. Silakan cek inbox email Anda untuk instruksi reset password.');
    } catch (error) {
      console.error('Reset password error:', error);
      
      // Handle specific Firebase errors
      let errorMessage = 'Terjadi kesalahan saat mengirim email reset password.';
      
      if (error.code === 'auth/user-not-found') {
        errorMessage = 'Email tidak terdaftar dalam sistem.';
      } else if (error.code === 'auth/invalid-email') {
        errorMessage = 'Format email tidak valid.';
      } else if (error.code === 'auth/too-many-requests') {
        errorMessage = 'Terlalu banyak permintaan. Silakan coba lagi nanti.';
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container>
        <div className="login-container" style={{ maxWidth: '500px', margin: '0 auto' }}>
          <div className="login-form">
            <img src="/logo-rekos.png" alt="Logo Rekayasa Kosmetik" className="login-logo" />
            <h2 className="login-title">Lupa Password</h2>
            <p className="text-muted text-center mb-4">
              Masukkan email Anda. Kami akan mengirimkan instruksi untuk mereset password.
            </p>
            
            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">{success}</Alert>}
            
            <Formik
              initialValues={{ email: '' }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.email && errors.email}
                      placeholder="Masukkan email Anda"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>
                  
                  <Button 
                    disabled={loading || success} 
                    className="w-100 mt-4 login-btn" 
                    type="submit"
                  >
                    {loading ? 'Mengirim...' : success ? 'Email Terkirim' : 'Kirim Email Reset Password'}
                  </Button>
                  
                  <div className="login-links mt-4 text-center">
                    <Link to="/login" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                      <FaArrowLeft /> Kembali ke Login
                    </Link>
                  </div>
                </Form>
              )}
            </Formik>
            
            {success && (
              <Alert variant="info" className="mt-3">
                <strong>Catatan:</strong> Jika email tidak muncul di inbox, cek folder spam atau junk mail. 
                Link reset password akan berlaku selama 1 jam.
              </Alert>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ForgotPassword;

